
import * as cloudflareRuntime$GaocNF_45Ej2VQg_45Lgs9Z_45gs8j2BX3bzXtNmtCNGh28qg from '/Users/david/clawd/localauthority/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_@libsql+client@0.15.5_better-sqlite3@11.10.0_drizzle-orm@0.43.1__ney3zdscerfwcahd2so6qlt5fi/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$GaocNF_45Ej2VQg_45Lgs9Z_45gs8j2BX3bzXtNmtCNGh28qg, defaults: {"baseURL":"https://localauthority.au"} }
}
        